import { Grid, Stack } from '@mantine/core';

import React from 'react';
import OrderPositionTable from './Order/OrderPositionTable';
import DeliveryTable from './Delivery/DeliveryTable';

function ShipmentPanel() {
  return (
    <Stack>
      <Grid>
        <Grid.Col md={6} lg={6}>
          <Stack>
            <OrderPositionTable />
          </Stack>
        </Grid.Col>
        <Grid.Col md={6} lg={6}>
          <Stack>
            <DeliveryTable />
          </Stack>
        </Grid.Col>
      </Grid>
    </Stack>
  );
}

export default ShipmentPanel;
